import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from '../../Hooks/useLangflowChat';
import { useScroll } from '../../Hooks/useScroll';
import LoadingSparkles from './LoadingSparkles/LoadingSparkles';
import { LangflowMessageItem } from './LangflowMessageItem/LangflowMessageItem';
import './LangflowMessages.scss';

interface LangflowMessagesProps {
  messages: Message[];
  isLoading: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

export const LangflowMessages = ({
  messages,
  isLoading,
  messagesEndRef,
}: LangflowMessagesProps) => {
  const { t } = useTranslation();
  const { hasScrollbar, messagesContainerRef } = useScroll(messages);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div
      ref={messagesContainerRef}
      className={`langflow-chat-messages ${hasScrollbar ? 'has-scrollbar' : 'no-scrollbar'}`}
    >
      {messages.map((message) => (
        <LangflowMessageItem key={message.id} message={message} />
      ))}
      {isLoading && <LoadingSparkles loadingText={t('chat:thinking')} />}
      <div ref={messagesEndRef} />
    </div>
  );
};
